// extracted by mini-css-extract-plugin
export var largeTile = "FancyList-module--largeTile--24f91";
export var mediumTile0 = "FancyList-module--mediumTile0--801a8";
export var mediumTile1 = "FancyList-module--mediumTile1--10eee";
export var mediumTile2 = "FancyList-module--mediumTile2--24cd0";
export var mediumTile3 = "FancyList-module--mediumTile3--a3bb9";
export var mediumTile4 = "FancyList-module--mediumTile4--5dbe8";
export var mediumTile5 = "FancyList-module--mediumTile5--a01a5";
export var mediumTile6 = "FancyList-module--mediumTile6--f577f";
export var mediumTile7 = "FancyList-module--mediumTile7--cdfd3";
export var mediumTile8 = "FancyList-module--mediumTile8--7feda";
export var mediumTile9 = "FancyList-module--mediumTile9--860cd";
export var root = "FancyList-module--root--7f382";
export var tile = "FancyList-module--tile--d6d5f";
export var withLargeTiles = "FancyList-module--withLargeTiles--e8884";